// extracted by mini-css-extract-plugin
export default {"icon":"RespIcon_icon__hZMPs","badge":"RespIcon_badge__9H0wE","sm":"RespIcon_sm__y-Wz+","md":"RespIcon_md__F2eXz","lg":"RespIcon_lg__eq5H6"};